import Vue from 'vue'
import VueLogger from 'vuejs-logger';
import VuePageTitle from 'vue-page-title';
// import VueGtag from 'vue-gtag';
// Vue.use(VueGtag

import App from './App.vue'
import router from './router'
import store from '@/store/Store'
import Home from '@/views/Home'

//logging
const isProduction = process.env.NODE_ENV === 'production';
const logops = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : false, //is usually useless
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, logops);
Vue.use(VuePageTitle, {prefix: 'Tasker', router: router});


Vue.$log.debug('main.js');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  Home,
  render: h => h(App)
}).$mount('#app')
